import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FirebaseService } from '../../common/firebase/firebase.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VideoAiModerateService {

  noodleVisible = signal<{
    brief_accuracy: boolean;
    brief_improvement: boolean;
    draft_item: boolean;
    video_feedback: boolean;
    results_overall_accuracy: boolean;
  }>({
    brief_accuracy: true,
    brief_improvement: true,
    draft_item: true,
    video_feedback: true,
    results_overall_accuracy: true,
  });

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);



  getReviewByVideoId(videoId: string) {
    const get_ai_review_url = `${environment.shout_api.url}/video-ai-moderate/get_review_by_video_id/${videoId}`;
    return this.http.get<any>(get_ai_review_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  retryContentReview(videoId: string) {
    const retry_content_review_url = `${environment.shout_api.url}/video-ai-moderate/retry/content-review`;
    return this.http.post<any>(retry_content_review_url, { videoId }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  /** Noodle Question End Points */
  getNoodleQuestions(briefId: string) {
    const get_noodle_questions_url = `${environment.shout_api.url}/video-ai-moderate/human-in-loop/questions/${briefId}`;
    return this.http.get(get_noodle_questions_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getNoodleQuestionTrends(briefId: string) {
    const get_noodle_question_trends_url = `${environment.shout_api.url}/video-ai-moderate/human-in-loop/trends/${briefId}`;
    return this.http.get(get_noodle_question_trends_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  approveBriefQuestions(briefId: string): Observable<{ noodleResponse: any, kanbanProgress: any}> {
    const approve_brief_questions_url = `${environment.shout_api.url}/video-ai-moderate/human-in-loop/approve/${briefId}`;
    return this.http.get<{ noodleResponse: any, kanbanProgress: any}>(approve_brief_questions_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  updateBriefQuestions(questions: {
    briefId: string;
    briefIntId: string | null;
    briefName: string;
    briefStatus: string;
    briefType: string;
    organizationId: string;
    questionsCount: number;
    questions: {
      id: string;
      type: string;
      statement: string;
      questionType: number;
      subjectiveType: number;
    }[];
  }) {

    const update_brief_questions_url = `${environment.shout_api.url}/video-ai-moderate/human-in-loop/update-questions`;
    return this.http.post(update_brief_questions_url, questions, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
  /** Noodle Question End Points - END */

}
